export const testimonialImages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/qwvdzE8qQ4dXPwfJ14oNYf/01-instagram-mensaje_(1).webp',
    alt: 'Mensaje directo de Instagram de una instructora contando que le vino genial tener ya la estructura montada para su clase de Reformer'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/teFFrJGK72UaQTTvY31tt4/02-instagram-comentario_(1).webp',
    alt: 'Comentario de Instagram de una instructora diciendo que las correcciones y las opciones más fáciles le sirven más que los ejercicios en sí'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3bjxtb9J6dQuN7LuP9PFRu/03-facebook-mensaje_(1).webp',
    alt: 'Mensaje de Facebook Messenger de una instructora contando que usa el material para sacar ideas y no repetir siempre lo mismo'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6hGWVUMcj52UmyPFvzTLHv/04-facebook-comentario_(1).webp',
    alt: 'Comentario de Facebook de una instructora contando que terminó usando muchísimo el tomo de accesorios'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/xjqtbW1m5Uvv1YtaJzVDC4/05-correo_(1).webp',
    alt: 'Correo electrónico de una instructora explicando cómo el selector le está ayudando a preparar clases más rápido'
  }
];
